import React from 'react';
import PropTypes from 'prop-types';
import './InlineDotsLoader.scss';

/**
 * Inline three dots loader for payment amounts
 * Displays inline with text to prevent layout shift
 */
const InlineDotsLoader = ({ className = '' }) => {
	return (
		<span
			className={`inline-dots-loader ${className}`}
			data-testid="inline-dots-loader"
		>
			<span className="dot dot-1" />
			<span className="dot dot-2" />
			<span className="dot dot-3" />
		</span>
	);
};

InlineDotsLoader.propTypes = {
	className: PropTypes.string
};

export default InlineDotsLoader;
